import {useState} from 'react';
export default function MapControlsToggleBtn({state, onClick, title, children}){

    function _onClick(e){
        if(onClick) onClick(e, !state);
    }

    return (
        <button onClick={e=>_onClick(e)} title={title} className='bg-white border rounded-sm w-8 border-b block p-1 mb-2'>
            {children && children[state?1:0]}
        </button>
    )
}